module.exports = __webpack_public_path__ + "static/img/1600.fd19f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/1600.png
// module id = nGEC
// module chunks = 2